export function setValueIndex(_ref) {
  let {
    values,
    source,
    newValue,
    index
  } = _ref;
  // Performance shortcut
  if (source[index] === newValue) {
    return source;
  }
  const output = values.slice();
  output[index] = newValue;
  return output;
}